<div class="c-review">
  <div class="c-review__container row">
    <div class="c-review__summary-card col-xs-12 col-sm-12 col-md-7 ">
      <!-- DELIVERY NOTE NUMBER SECTION -->
      <div class="delivery-note-number">
        @if (deliveryNoteNumber) {
          <cx-card
            [content]="getDeliveryNoteNumber() | async">
          </cx-card>
        }
      </div>

      <!-- DELIVERY DATE SECTION -->
      <div class="date-section">
        @if (creationDate) {
          <cx-card
            [content]="getCreationDate() | async">
          </cx-card>
        }
      </div>

      <!-- WAREHOUSE NAME SECTION -->
      <div class="name-section">
        @if (warehouseName) {
          <cx-card
            [content]="getWarehouseName() | async">
          </cx-card>
        }
      </div>

    </div>
    <div class="c-review__summary-card col-xs-12 col-sm-12 col-md-5 address-section">
      <!-- WAREHOUSE NAME SECTION -->
      @if (receiverAddress) {
        <cx-card
          [content]="getReceiverAddress() | async">
        </cx-card>
      }
    </div>
  </div>
</div>
